module.exports = __webpack_public_path__ + "gerbo.jpg?2205a3fdc03304dea3cdc3330922aa1d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projetos/gerbo.jpg
// module id = 117
// module chunks = 0